import { z } from 'zod'

export const AGENTMCP_RECIPE_READ_CONTRACT_VERSION = '1.0.0' as const

export const agentmcpRecipeRunResponseSchema = z.object({
  run_id: z.string(),
  status: z.string(),
}).passthrough()

export type AgentmcpRecipeRunResponse = z.infer<typeof agentmcpRecipeRunResponseSchema>
